import { Component, Input, OnInit } from '@angular/core';

import { IAtxBadgeConfig } from '../interfaces';
import { COLORS, DEFAULT_CONFIG } from '../constants';

@Component({
    selector: 'atx-badge',
    template: `<span class="badge badge-{{ config?.type }}"
      [class.badge-pill]="config?.radius"
      [innerHTML]="config?.label">
</span>
`,
    styles: [``],
})

export class AtxBadgeComponent implements OnInit {
    @Input() public readonly config: IAtxBadgeConfig = DEFAULT_CONFIG;

    public ngOnInit() {
        this.config.type = (this.config.type in COLORS) ? this.config.type : COLORS.light;
    }
}
